import { render } from "./collapse.vue?vue&type=template&id=327a39ad"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "327a39ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('327a39ad', __exports__)) {
    console.log('reload')
    api.reload('327a39ad', __exports__)
  }
  
  module.hot.accept("./collapse.vue?vue&type=template&id=327a39ad", () => {
    console.log('re-render')
    api.rerender('327a39ad', render)
  })

}


export default __exports__